import React from "react";

export interface LogoEntry {
  label: string;
  style?: "default" | "italic" | "mono" | "serif";
}

interface LogosStripProps {
  label?: string;
  entries: LogoEntry[];
}

const LogosStrip: React.FC<LogosStripProps> = ({ label = "Unifies ↗", entries }) => {
  return (
    <section className="cs-logos-strip">
      <div className="cs-logos-inner">
        <div className="cs-logos-label">{label}</div>
        <div className="cs-logos-row">
          {entries.map((entry) => (
            <span key={entry.label} className={entry.style && entry.style !== "default" ? entry.style : undefined}>
              {entry.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogosStrip;
